import DownloadReport from "./DownloadReport";
function App() {
  return <DownloadReport />;
}
export default App;